import type { Ref } from 'react'

import type { FormikProps } from 'formik'

import { ballotDetailsContent } from 'app/components/Ballot/constants'
import BallotDisclosures from 'app/components/Ballot/Disclosures'
import type { BallotsHouseholdIncomeLimit } from 'app/components/Ballot/Disclosures/Formbody'
import { Alert, Box } from 'app/components/design-system-components'
import { isMirvacTeam } from 'app/utils/text/helpers'

type BallotDetailsProps = {
  formRef: Ref<FormikProps<object>>
  ballotsHouseholdIncomeLimit: BallotsHouseholdIncomeLimit
  ballotsHouseholdIncomeRegion: string
  ballotDisclosuresAnswers: any[]
  teamSlug: string
  ballotHouseholdIncomeYear: string
}

export const DefaultBallotDetailsContent = () => (
  <>
    <Box>
      Homes Victoria affordable Housing creates an alternative to the private
      rental market to help low to moderate income Victorian renters access high
      quality housing at an affordable rent. Please visit the Affordable Housing
      website at{' '}
      <a href="https://www.homes.vic.gov.au/homes-victoria-affordable">
        https://www.homes.vic.gov.au/homes-victoria-affordable
      </a>{' '}
      for information on who is eligible to apply and the ballot process.
    </Box>
    <Box mt={2}>
      {' '}
      To apply for a Homes Victoria affordable home, you will need to comply
      with the eligibility checklist below.
    </Box>
    <Box mt={2}>
      If you are successfully drawn from the ballot, you will be required within
      2 days to provide proof of your eligibility in the form of recent
      payslips, identification and visa status.
    </Box>
    <Box mt={2}>
      If the checklist determines that you are unsuccessful, you will not
      progress to apply for a Homes Victoria affordable home.
    </Box>
  </>
)

export const MirvacBallotDetailsContent = () => (
  <Box>
    Affordable housing creates an alternative to the private rental market to
    help low to moderate income renters access high quality housing at an
    affordable rent. To apply for anaffordable home, you will need to comply
    with the eligibility checklist below.
  </Box>
)

const MirvacBallotDetailsEndContent = () => (
  <>
    <Box mt={2}>
      If you are successfully drawn from the ballot, you will be required within
      2 days to provide proof of your eligibility in the form of recent
      payslips, identification and visa status.
    </Box>
    <Box mt={2}>
      If the checklist determines that you are unsuccessful, you will not
      progress to apply for an affordable home.
    </Box>
  </>
)

export const QldAffordableBallotDetailsContent = () => (
  <Box>
    <Box>
      The Housing Investment Fund (HIF) provides affordable housing solutions
      for low to moderate income households, who can access high quality housing
      at an affordable rent. Please visit the National Affordable Housing
      website at{' '}
      <a
        href="https://nahc.org.au/documents/Tetris_-_Affordable_Housing_Eligibility_Criteria_-_Low_Income.docx_.pdf"
        target="_blank"
        rel="noreferrer"
      >
        https://www.nahc.org.au
      </a>{' '}
      for information on who is eligible to apply and the ballot process.
    </Box>
    <Box mt={2}>
      To apply for a HIF Affordable Housing dwelling, you will need to comply
      with the eligibility checklist below.
    </Box>
    <Box mt={2}>
      If you are successfully drawn from the ballot, you will be required within
      2 days to provide proof of your eligibility in the form of recent
      payslips, identification and visa status.
    </Box>
    <Box mt={2}>
      If the checklist determines that you are unsuccessful, you will not
      progress to apply for a HIF Affordable Housing dwelling.
    </Box>
  </Box>
)

function BallotDetails({
  formRef,
  ballotsHouseholdIncomeLimit,
  ballotsHouseholdIncomeRegion,
  ballotDisclosuresAnswers,
  teamSlug = '',
  ballotHouseholdIncomeYear,
}: BallotDetailsProps) {
  const isMirvac = isMirvacTeam(teamSlug)
  return (
    <Alert variant="blueWithBg">
      <Box color="black">
        <h2>Ballot details</h2>
        {ballotDetailsContent(teamSlug)}
        <BallotDisclosures
          formRef={formRef}
          ballotsHouseholdIncomeLimit={ballotsHouseholdIncomeLimit}
          ballotDisclosuresAnswers={ballotDisclosuresAnswers}
          ballotsHouseholdIncomeRegion={ballotsHouseholdIncomeRegion}
          isMirvac={isMirvac}
          teamSlug={teamSlug}
          ballotHouseholdIncomeYear={ballotHouseholdIncomeYear}
        />
        {isMirvac && <MirvacBallotDetailsEndContent />}
      </Box>
    </Alert>
  )
}

export default BallotDetails
